jQuery('.collection-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 987,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 780,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
  ]
});


jQuery('.logolist__holder-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 987,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 780,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
  ]
});

$( ".filter__open-collapse" ).click(function() {
  var open = 1;
  jQuery('.filter__group').slice(1).each(function(i) {
    if(!$(this).hasClass("filter__group-collapse")){
      //add
      $(this).addClass("filter__group-collapse");
    }else {
      //remove
      $(this).removeClass("filter__group-collapse");
    }
  });

  if(jQuery('#filterSidebar').hasClass('filter__dropdown')){
    jQuery('#filterSidebar').removeClass('filter__dropdown');
  }else {
    jQuery('#filterSidebar').addClass('filter__dropdown');
  }
});